module.exports = __webpack_public_path__ + "static/img/H5-H5设计.8eab2e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10007/H5-H5设计.png
// module id = eKdw
// module chunks = 1